import { render, staticRenderFns } from "./CampaignLifetimeStats.vue?vue&type=template&id=3215a16e&"
import script from "./CampaignLifetimeStats.vue?vue&type=script&lang=js&"
export * from "./CampaignLifetimeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports